module.exports = __webpack_public_path__ + "nc_static/media/contact-hotline.1050c00f.svg";